import BigNumber from 'bignumber.js'
import { accountCairoVersion, getProvider, walletAddress } from './amm'
import { getStarknet } from './amm_v3'
import { Network } from './token.service'
import { Transaction } from '../atoms'
import { AccountInvocationItem, transaction } from 'starknet'
import { getStorageWallet } from '../utils'

const REWARDS_CONTRACT = '0x005763f02381e89c6894ffea078d1cf9e58da0ead33d5b52aa608acc04063053' //'0x06e514d5d41416a6051a0f49bbf27c412724d7bf73ebbb2d5940f759f97a116d' // '0x041a8941b06e711512dc5dd4c929f46b9848394721543537255417357bf52475'
export const getAlreadyClaimedAmount = async (network: Network): Promise<string> => {
    try {
        const starknet = await getStarknet()

        let activeAccount: string = getStorageWallet() || walletAddress()
        if (!activeAccount) {
            return '0'
        }

        if (!starknet?.isConnected) throw Error('starknet wallet not connected')

        const response = await (
            await getProvider(network)
        ).callContract({
            entrypoint: 'amount_already_claimed',
            calldata: [activeAccount],
            contractAddress: REWARDS_CONTRACT
        })

        //console.log("YSYS activeAccount=",activeAccount," amount_already_claimed=",response.result[0])
        const a = new BigNumber(response.result[0])
        return a.toFixed()
    } catch (e: any) {
        throw new Error('error amount_already_claimed ' + e.message)
    }
}

export const claimReward = async (
    network: Network,
    lifetimeAmount: string,
    proof: string[]
): Promise<
    | {
          tx?: Transaction
          error?: string
          success: boolean
      }
    | undefined
> => {
    const starknet = await getStarknet()

    let activeAccount: string = walletAddress()
    if (!activeAccount) {
        return undefined
    }
    if (!starknet?.isConnected) throw Error('starknet wallet not connected')
    const calls = [
        {
            contractAddress: REWARDS_CONTRACT,
            entrypoint: 'claim',
            calldata: [lifetimeAmount, proof.length, ...proof]
        }
    ]
    const handler = accountCairoVersion() === '1' ? transaction.fromCallsToExecuteCalldata_cairo1 : transaction.fromCallsToExecuteCalldata

    const invocation: AccountInvocationItem = {
        signature: [],
        // @ts-ignore
        type: 'INVOKE_FUNCTION',
        nonce: await (await getProvider(network)).getNonceForAddress(starknet.account.address),
        entrypoint: '__execute__',
        contractAddress: starknet.account.address,
        calldata: handler(calls)
    }

    // invoke
    try {
        // @ts-ignore
        let tx = await starknet.account.execute(calls)

        const transaction: Transaction = {
            hash: tx.transaction_hash,
            network,
            status: 'new',
            type: 'claim_reward',
            dismiss: false,
            token1: '',
            token1Amount: '',
            token2: '',
            token2Amount: ''
        }
        return { tx: transaction, success: true }
    } catch (e) {
        return { error: 'Failed to remove liquidity', success: false }
    }
}
